import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./i18n";
import i18n from "./i18n";

// Set Portuguese (pt-BR) as default language on the <html> tag
const setHtmlLang = (lng) => {
  const normalized = !lng || lng === "ar" || lng === "pt" ? "pt-BR" : lng;
  document.documentElement.lang = normalized;
};

setHtmlLang(i18n.language || "pt-BR");

i18n.on("languageChanged", (lng) => {
  setHtmlLang(lng);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
